import { render } from "./ArticleModal.vue?vue&type=template&id=2bddd398&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"

import "./ArticleModal.vue?vue&type=style&index=0&id=2bddd398&lang=stylus&scoped=true"
import "./ArticleModal.vue?vue&type=style&index=1&id=2bddd398&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bddd398"]])

export default __exports__